import { render, staticRenderFns } from "./PuzzleController.vue?vue&type=template&id=2812f022&scoped=true"
import script from "./PuzzleController.vue?vue&type=script&lang=js"
export * from "./PuzzleController.vue?vue&type=script&lang=js"
import style0 from "./PuzzleController.scss?vue&type=style&index=0&id=2812f022&prod&scoped=true&lang=scss&external"
import style1 from "./PuzzleController.vue?vue&type=style&index=1&id=2812f022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812f022",
  null
  
)

export default component.exports